export enum Persistence {
  None = 0,
  Dive = 1,
  Game = 2,
  Permanent = 3,
}
